/**
 * @format
 */
import { Injectable } from "@angular/core";
import { BaseToolService } from "../../ng-editor/services/base-tool.service";
import { PreviewEditTemplateActions } from "../../preview-edit-template/state/preview-edit-template.actions";
import { Store } from "@ngrx/store";

@Injectable({
   providedIn: "root",
})
export class CleanVariableOnPasteService extends BaseToolService {
   constructor(private store: Store<any>) {
      super();
   }

   setClenTextInRange(selection: Selection, cleanText: string): void {
      const range = selection.getRangeAt(0);

      // Replace the selected text with the modified text
      range.deleteContents();
      const span = document.createElement("SPAN");
      span.id = "TO_REMOVE";
      span.innerHTML = cleanText;
      range.insertNode(span);
      range.setStartAfter(range.endContainer);

      // Delay updating the selection until the current event loop has finished
      setTimeout(function () {
         // Update the selection
         try {
            const element = document.getElementById("TO_REMOVE");
            const newRange = new Range();
            let nodeToSetAsRange: Node;

            if (Boolean(element.nextSibling)) {
               nodeToSetAsRange = element.nextSibling;
               newRange.setStart(nodeToSetAsRange, 0);
               newRange.setEnd(nodeToSetAsRange, 0);
               selection.removeAllRanges();
               selection.addRange(newRange);
               element.replaceWith(cleanText);
            } else {
               const parentNode = element.parentNode;
               element.replaceWith(cleanText);
               const index = parentNode.lastChild.nodeValue.length;
               newRange.setStart(parentNode.lastChild, index);
               newRange.setEnd(parentNode.lastChild, index);
               selection.removeAllRanges();
               selection.addRange(newRange);
            }
         } catch (error) {
            console.error("(custom error) ", error.value);
         }
      }, 0);
   }

   removeSpaceOrNewline(text: string): string {
      const regExp = new RegExp(/\s/, "g");
      return text.replace(regExp, " ");
   }

   updateTemplateModelVariable(modelVariableValue: string, modelVariableName): void {
      const objectPayload = { variableName: modelVariableName, value: modelVariableValue, reloadPreview: false };
      this.store.dispatch(PreviewEditTemplateActions.templateUpdateModelVariable(objectPayload));
   }
}
